import { Typography } from '@mui/material';
import { t } from '@ankr.com/common';

import {
  IUseProjectStatusLabelProps,
  useProjectStatusLabel,
} from './hooks/useProjectStatusLabel';
import { useProjectStatusLabelStyles } from './useProjectStatusLabelStyles';
import { ProjectStatusLabelType } from '../../const';

export interface ProjectStatusLabelProps extends IUseProjectStatusLabelProps {
  className?: string;
  hasDivider?: boolean;
}

export const ProjectStatusLabel = ({
  className,
  hasDivider,
  isDraft,
  status,
}: ProjectStatusLabelProps) => {
  const { projectStatusType } = useProjectStatusLabel({
    isDraft,
    status,
  });

  const { classes, cx } = useProjectStatusLabelStyles(projectStatusType);

  if (projectStatusType === ProjectStatusLabelType.Active) {
    return null;
  }

  return (
    <>
      <Typography
        className={cx(classes.projectStatusLabel, className)}
        variant="body4"
      >
        {t(`projects.list-project.${projectStatusType}`)}
      </Typography>
      {hasDivider && <span className={classes.divider}>•</span>}
    </>
  );
};
